const LANGUAGES = ['zh-cn']

const getCurrentRoute = (route) => {
  const routePath =
    route.path === '/' ? 'home' : route.fullPath.replace('/', '')
  // const lang = 'en'
  // let path = ''

  const splitPath = routePath.split('/')

  if (splitPath.length > 1 && LANGUAGES.includes(splitPath[0])) {
    const [lang, ...rest] = splitPath

    // translation
    // lang = splitPath[0]
    // path = splitPath[1] === '' ? 'home' : splitPath[1]
    const path = rest.join('/') === '' ? 'home' : rest.join('/')
    return [lang, path]
  } else {
    const path = routePath // splitPath[0]
    const lang = 'en'
    return [lang, path]
  }
}

export default getCurrentRoute
